var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.812,
    height: 31.783,
    viewBox: "0 0 31.812 31.783",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "interface_call_phone_calling",
    "data-name": "interface, call, phone, calling",
    d: "M13.16,10a4.353,4.353,0,0,0-.911-4.815L9.331,2.272A4.289,4.289,0,0,0,5.617,1.05,4.336,4.336,0,0,0,2.4,3.34a12,12,0,0,0-1.017,8.653c1.865,7.386,12.016,17.544,19.4,19.395a12.494,12.494,0,0,0,3.049.383,11.954,11.954,0,0,0,5.6-1.4A4.348,4.348,0,0,0,30.5,23.446l-2.917-2.918a4.355,4.355,0,0,0-4.816-.911A6.786,6.786,0,0,0,20.712,21c-.713.718-3.345-.322-5.979-2.954s-3.67-5.264-2.961-5.98A6.8,6.8,0,0,0,13.16,10Zm-.408,10.021c3.207,3.2,7.521,5.366,9.932,2.954a4.056,4.056,0,0,1,1.221-.8,1.539,1.539,0,0,1,1.7.334l2.917,2.917a1.522,1.522,0,0,1,.434,1.316,1.557,1.557,0,0,1-.827,1.157,9.117,9.117,0,0,1-6.667.778C15.114,27.076,5.7,17.663,4.1,11.31A9.134,9.134,0,0,1,4.88,4.638a1.56,1.56,0,0,1,1.157-.821A1.46,1.46,0,0,1,6.271,3.8a1.522,1.522,0,0,1,1.083.452L10.27,7.167a1.539,1.539,0,0,1,.334,1.7,4.057,4.057,0,0,1-.8,1.23C7.388,12.5,9.547,16.807,12.751,20.025Z",
    transform: "translate(-0.471 -0.488)",
    stroke: "#fff",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.861c90c34ebc4ba8e8d4816c61587d49.svg";
export { ForwardRef as ReactComponent };